<form [formGroup]="createInstanceForm" class="create-instance-form">
  <div class="flex flex-col">
    <div class="flex-col form-field">
      <div class="flex-row mb-4">
        <div class="h-64" *ngIf="editMode">
          <h2 class="fs-24 fw-700 m-0">{{ title }}</h2>
          <p class="fs-16 fw-500 m-0">{{ subtitle }}</p>
          <mat-icon svgIcon="close" class="close-icon w-32 h-32" (click)="sidenavService.closeRightSidenav()"></mat-icon>
        </div>
        <hr class="separator" />
        <label class="fs-12 fw-700 instance-label-align">{{'INSTANCE_SUMMARY.INSTANCE_NAME' | transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="editMode ? ('INSTANCE_SUMMARY.INSTANCE_NAME' | transloco) : ('INSTANCE_SUMMARY.TOOLTIP.INSTANCE_NAME' | transloco)"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          <span *ngIf="!editMode" class="mandatory mt--12 mat-body-2">*</span>
      </div>
      <input *ngIf="!editMode" formControlName="name" placeholder="{{'INSTANCE_SUMMARY.INSTANCE_NAME' | transloco}}" class="fw-400" (click)="onClick()" (keyup)="verifyDuplicate()" required>
      <p  *ngIf="editMode" class="flex items-center rounded px-4 py-3 m-0 disabled-input" readonly >{{name || '-'}}</p>
      <app-error [control]="createInstanceForm.get('name')"></app-error>
      <div *ngIf="instanceName else disablebutton">
        <button class="link-field mt-5 fw-400 pl-12">
          <div class="flex items-center">
            <ng-container *ngIf="deployment?.dataZone === DataZone.LIVE && !editMode; else nonProdTemplate">
              <span class="button-text">
                {{blueprint.name | trim | lowercase}}-{{createInstanceForm.get('name').value | trim | lowercase}}.{{tenantDetails.tenantId}}.{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.TEMENOSBANKINGPROD_CLOUD' | transloco}}
              </span>
            </ng-container>
            <ng-template #nonProdTemplate>
              <span class="button-text">
                {{blueprint.name | trim | lowercase}}-{{createInstanceForm.get('name').value | trim | lowercase}}.{{tenantDetails.tenantId}}.{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.TEMENOSBANKINGNONPROD_CLOUD' | transloco}}
              </span>
            </ng-template>
          </div>
        </button>
      </div>
      <ng-template #disablebutton>
        <button class="link-field mt-5 fw-200 hide">
          <div *ngIf="deployment?.dataZone !== DataZone.LIVE && !editMode; else prodEnvironments" class="flex items-center">
            <span class="button-text">{{blueprint.name | trim | lowercase}}-{{createInstanceForm.get('name').value | trim | lowercase}}.{{tenantDetails.tenantId}}.{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.TEMENOSBANKINGNONPROD_CLOUD' | transloco}}</span>
          </div>
          <ng-template *ngIf="!editMode" #prodEnvironments>
            <span class="button-text">{{blueprint.name | trim | lowercase}}-{{createInstanceForm.get('name').value | trim | lowercase}}.{{tenantDetails.tenantId}}.{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.TEMENOSBANKINGPROD_CLOUD'| transloco}}</span>
          </ng-template>
        </button>
      </ng-template>
    </div>
    <div *ngIf="!editMode" class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12 fw-700 instance-label-align">{{'INSTANCE_SUMMARY.SERVICE_DEFINITION.SERVICE_DEFINITION' | transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.SERVICE_DEFINITION_VERSION' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <select [ngClass]="{'placeholder-color': createInstanceForm.get('blueprintVersionId')?.value === ''}" class="form-select" (change)="getVersion($event.target.value)" [formControl]="createInstanceForm.get('blueprintVersionId')">
        <option value="" [selected]="true" disabled hidden>{{'BLUEPRINT_SUMMARY.SELECT_VERSION'| transloco}}</option>
        <option *ngFor="let version of versions" [ngValue]="version.id">{{'INSTANCE_SUMMARY.SERVICE_DEFINITION.VERSION' | transloco}} {{ version.version }}</option>
      </select>
      <app-error [control]="createInstanceForm.get('blueprintVersionId')"></app-error>
    </div>
    <div *ngIf="!editMode" class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12 fw-700 instance-label-align">{{'BLUEPRINT_SUMMARY.DEPLOYMENT_CLASS'| transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'BLUEPRINT_SUMMARY.DEPLOYMENT_CLASS' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <select class="form-select" [formControl]="createInstanceForm.get('deploymentClass')" *ngIf="nonPtlFlow || pathToLiveStatus || devFlow" [ngClass]="{ 'placeholder-color': createInstanceForm.get('deploymentClass')?.value === '', 'disabled disabled-select': isDataZoneDropdownDisabled()}">
        <option value="" disabled hidden selected>{{'BLUEPRINT_SUMMARY.SELECT_CLASS'| transloco}}</option>
        <!-- <option disabled selected>{{'NON_PTL.SELECT_DEPLOYMENT_CLASS'| transloco}}</option> -->
        <option *ngFor="let class of classDropdown" [value]="class">{{class}}</option>
      </select>
      <app-error [control]="createInstanceForm.get('deploymentClass')"></app-error>
    </div>
    <div *ngIf="!pathToLiveStatus && !nonPtlFlow" class="flex-col form-field">
      <div *ngIf="!pathToLiveStatus" class="flex-row mb-4">
        <label class="fs-12 fw-700 instance-label-align">{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.DATA_ZONE' | transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.DATA_ZONE' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <input *ngIf="!pathToLiveStatus" [value]="getDataZoneValue()" placeholder="{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.DATA_ZONE' | transloco}}" class="fw-400 disabled-input" readonly>
     </div>
    <div *ngIf="nonPtlFlow || pathToLiveStatus">
      <div *ngIf="!editMode" class="flex-col form-field">
        <div class="flex-row mb-4">
          <label class="fs-12 fw-700 instance-label-align">{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.DATA_ZONE' | transloco | uppercase}}</label>
          <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.DATA_ZONE' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <select class="form-select" [ngClass]="{'placeholder-color': createInstanceForm.get('dataZone')?.value === '', 'disabled disabled-select': isDataZoneDisabledForClassD()}" *ngIf="enableDataZoneDropdown" [formControl]="createInstanceForm.get('dataZone')">
          <option value="" disabled hidden selected>{{'NON_PTL.SELECT_DATAZONE'| transloco}}</option>
          <option value="nonpii">{{DataZone.DEVELOPMENT | titlecase}}</option>
          <option value="pii">{{DataZone.SECURE | titlecase}}</option>
        </select>
        <input *ngIf="!nonPtlFlow && disableWithDefault" [value]="createInstanceForm.get('dataZone')?.value | titlecase" class="w-100-percent disabled-input fw-400">
        <app-error [control]="createInstanceForm.get('dataZone')"></app-error>
      </div>
      </div>
    <div class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12 fw-700 instance-label-align">{{'BLUEPRINT_SUMMARY.RELEASE'| transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.SOLUTION_RELEASE' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <select [ngClass]="{'placeholder-color': createInstanceForm.get('buildNumber')?.value === ''}" class="form-select" *ngIf="!editMode" [formControl]="createInstanceForm.get('buildNumber')" (change)="getBuildVersion($event.target.value)">
        <option value="" disabled hidden selected>{{'BLUEPRINT_SUMMARY.SELECT_SOLUTION_VERSION'| transloco}}</option>
        <option *ngFor="let buildNumber of finalBuild" [value]="buildNumber?.version">{{buildNumber?.releaseVersion}}</option>
      </select>
      <p *ngIf="editMode" class="flex items-center rounded px-4 py-3 m-0 disabled-input" readonly >{{releaseVersion || '-'}}</p>
      <app-error [control]="createInstanceForm.get('buildNumber')"></app-error>
    </div>
    <div class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12 fw-700 instance-label-align">{{'BLUEPRINT_SUMMARY.REQUEST_ORIGNATION'| transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.REQUEST_ORIGNATION' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          <span *ngIf="!editMode" class="mandatory mt--12 mat-body-2">*</span>
      </div>
       <select [ngClass]="{'placeholder-color': createInstanceForm.get('requestOrigination')?.value === ''}" class="form-select" *ngIf="!editMode" [formControl]="createInstanceForm.get('requestOrigination')" [attr.disabled]="true">
        <option value="" disabled hidden selected>{{ 'BLUEPRINT_SUMMARY.SELECT_ORIGINATION' | transloco }}</option>
        <option value="Contract">{{'BLUEPRINT_SUMMARY.CONTRACT' | transloco}}</option>
        <option value="Internal">{{'BLUEPRINT_SUMMARY.INTERNAL' | transloco}}</option>
      </select>
      <p  *ngIf="editMode" class="flex items-center rounded px-4 py-3 m-0 disabled-input" readonly >{{requestOrigination || '-'}}</p>
      <app-error [control]="createInstanceForm.get('requestOrigination')"></app-error>
    </div>
    <div class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12 fw-700 instance-label-align">{{'BLUEPRINT_SUMMARY.CONTRACT_END_DATE'| transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.CONTRACT_END_DATE' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          <span *ngIf="!editMode" class="mandatory mt--12 mat-body-2">*</span>
      </div>
        <app-datepicker *ngIf="!editMode" [control]="createInstanceForm.get('contractEndDate')" [placeholder]="'BLUEPRINT_SUMMARY.SELECT_CONTRACT_END_DATE' | transloco" [min]="minDate" [max]="maxDate"></app-datepicker>
        <app-datepicker *ngIf="editMode" [control]="createInstanceForm.get('contractEndDate')" [placeholder]="'BLUEPRINT_SUMMARY.SELECT_CONTRACT_END_DATE' | transloco" [min]="minDate" [max]="maxDate"></app-datepicker>
        <app-error [control]="createInstanceForm.get('contractEndDate')"></app-error>
        <p *ngIf="editMode && shouldShowNote()" class="error-text fs-12 fw-400 mt-8 mb-0">{{ 'INSTANCE_SUMMARY.CONTRACT_NOTE' | transloco }}</p>
    </div>

    <div *ngIf="!nonPtlFlow">
    <div *ngIf="!editMode || !nonPtlFlow" class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12 fw-700 instance-label-align">{{'INSTANCE_SUMMARY.ENVIRONMENT' | transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.ENVIRONMENT' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <input *ngIf="!nonPtlFlow"  placeholder="{{'INSTANCE_SUMMARY.ENVIRONMENT' | transloco}}" class="fw-400" [value]="getEnvironmentValue()" readonly>
      <input *ngIf="!nonPtlFlow" hidden formControlName="targetEnvironment" placeholder="{{'INSTANCE_SUMMARY.ENVIRONMENT' | transloco}}" class="fw-400 disabled-input" readonly>
    </div>
    </div>

    <div *ngIf="!editMode && nonPtlFlow" class="flex-col form-field">
        <div *ngIf="nonPtlFlow" class="flex-row mb-4">
          <label class="fs-12 fw-700 instance-label-align">{{'INSTANCE_SUMMARY.ENVIRONMENT' | transloco | uppercase}}</label>
          <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.ENVIRONMENT' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <select class="form-select" *ngIf="!editMode" [formControl]="createInstanceForm.get('targetEnvironment')">
          <option *ngFor="let env of nonPtlEnv" [value]="env">{{env}}</option>
       </select>
        <!-- <input *ngIf="nonPtlFlow || pathToLiveStatus"  placeholder="{{'INSTANCE_SUMMARY.ENVIRONMENT' | transloco}}" class="fw-400 disabled-input" value="Other" readonly> -->
        <input *ngIf="nonPtlFlow || pathToLiveStatus" hidden formControlName="targetEnvironment" placeholder="{{'INSTANCE_SUMMARY.ENVIRONMENT' | transloco}}" class="fw-400 disabled-input" readonly>
      </div>

    <!-- <div *ngIf="deployment?.dataZone === DataZone.LIVE" class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12">{{ 'SERVICE.PREFERED_MAINTENANCE_DAY' | transloco | uppercase }}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltip=""
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <select [formControl]="createInstanceForm.get('dayOfTheWeek')">
        <option [ngValue]="null" [disabled]="true" hidden>{{'SERVICE.PREFERED_MAINTENANCE_DAY' | transloco}}</option>
        <option *ngFor="let day of weekDays; let i = index" [ngValue]="i">{{ day }}</option>
      </select>
      <app-error [control]="createInstanceForm.get('dayOfTheWeek')"></app-error>
    </div>

    <div *ngIf="deployment?.dataZone === DataZone.LIVE" class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12">{{ 'SERVICE.PREFERED_MAINTENANCE_TIME' | transloco | uppercase }}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltip=""
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <div class="flex flex-row">
        <div>
          <div class="maintenance-time">
            <div class="justify-items-center timepicker">
              <input [placeholder]="'SERVICE.FROM' | transloco" aria-label="12hr format" class="field-enabled"
                [formControl]="createInstanceForm.get('startingHour')" [ngxTimepicker]="startingHour" [format]="12" readonly>
              <mat-icon svgIcon="schedule" class="items-center mt-10 timepicker-icon" (click)="startingHour.open()"></mat-icon>
              <ngx-material-timepicker #startingHour></ngx-material-timepicker>
            </div>
          </div>
          <app-error [control]="createInstanceForm.get('startingHour')"></app-error>
        </div>
        <div>
          <div class="maintenance-time">
            <div class="justify-items-center timepicker">
              <input [placeholder]="'SERVICE.TO' | transloco" aria-label="12hr format" class="field-enabled"
                [formControl]="createInstanceForm.get('endingHour')" [ngxTimepicker]="endingHour" [format]="12" readonly>
              <mat-icon svgIcon="schedule" class="items-center mt-10 timepicker-icon" (click)="endingHour.open()"></mat-icon>
              <ngx-material-timepicker #endingHour></ngx-material-timepicker>
            </div>
          </div>
          <app-error [control]="createInstanceForm.get('endingHour')"></app-error>
        </div>
      </div>
    </div> -->

    <div *ngIf="!editMode" class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12 fw-700 instance-label-align">{{'INSTANCE_SUMMARY.SERVICE' | transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.SOLUTION_NAME' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <input placeholder="{{'INSTANCE_SUMMARY.SERVICE' | transloco}}" class="fw-400 disabled-input" value="{{service.name}}" readonly>
    </div>

    <div *ngIf="!editMode" class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12 fw-700 instance-label-align">{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.REGION' | transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.REGION' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <input formControlName="region" placeholder="{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.REGION' | transloco}}" class="fw-400 disabled-input" readonly>
    </div>
    <div *ngIf="editMode" class="flex flex-row gap-4" dir="rtl">
      <button class="accent" type="button" [disabled]="!isDateChanged" (click)="editContractEndDate(instance)" [ngClass]="{'disabled': !isDateChanged}">{{'BUTTONS.SUBMIT' | transloco}}</button>
      <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}
      </button>
    </div>
  </div>
</form>
